import { useSiteData } from 'dumi';
import React from 'react';
import "./index.less";
var Device = function Device(props) {
  var _useSiteData = useSiteData(),
    deviceWidth = _useSiteData.themeConfig.deviceWidth;
  return /*#__PURE__*/React.createElement("div", {
    className: "dumi-mobile-device",
    style: {
      width: deviceWidth,
      paddingTop: props.inlineHeight
    }
  }, /*#__PURE__*/React.createElement("iframe", {
    title: "dumi-previewer",
    src: props.url
  }));
};
export default Device;